import {BaseEntity, IBaseEntity} from 'app/blocks/model/base-entity.model';

export interface IExpenseType extends IBaseEntity {
    id?: number;
    name: string;
    subcontractExpense?: boolean;
    baseRate?: number;
    tariffId?: number;
    tariffName?: string;
    nominalCodeId?: number;
    nominalCodeCode?: string;
}

export class ExpenseType extends BaseEntity implements IExpenseType {
    public id?: number;
    public name: string;
    public subcontractExpense?: boolean;
    public baseRate?: number;
    public tariffId?: number;
    public nominalCodeId?: number;
    public nominalCodeCode?: string;

    constructor(expenseType?: any) {
        super();
        if (expenseType) {
            this.id = expenseType.id;
            this.name = expenseType.name;
            this.subcontractExpense = expenseType.subcontractExpense;
            this.baseRate = expenseType.baseRate;
            this.tariffId = expenseType.tariffId;
            this.nominalCodeId = expenseType.nominalCodeId;
            this.nominalCodeCode = expenseType.nominalCodeCode;
        }
    }

    get discriminator(): any {
        return this.name;
    }

    clone(): ExpenseType {
        return new ExpenseType(this);
    }
}
